module.exports = __webpack_public_path__ + "img/img9.06bee24b.svg";